import { Utensils, Camera, Store, Bath, ParkingSquare } from "lucide-react";

// Rider-facing category buttons. `kind` picks the data source; `param` is the
// value sent to the backend (businesses category / amenities type).
export const RIDER_CATEGORIES = [
  { key: "restaurants", label: "Restaurants", icon: Utensils, kind: "businesses", param: "restaurants", accent: "#F97316" },
  { key: "attractions", label: "Attractions", icon: Camera, kind: "businesses", param: "attractions", accent: "#10B981" },
  { key: "bike_shops", label: "Bike Shops", icon: Store, kind: "businesses", param: "bike_shops", accent: "#3B82F6" },
  { key: "bathroom", label: "Bathrooms", icon: Bath, kind: "amenities", param: "bathroom", accent: "#8B5CF6" },
  { key: "parking", label: "Parking", icon: ParkingSquare, kind: "amenities", param: "parking", accent: "#EAB308" },
];
